// extracted by mini-css-extract-plugin
export default {"readyBody":"brandProfile_readyBody__BesJ2"};